<div class="default-modal sv-modal info-dialog">
  <h2 mat-dialog-title>
    {{ title || 'Error de Sistema' }}
  </h2>
  <div mat-dialog-content>
    <p>{{ message || 'Tuvimos un problema. Favor recargar y volver a intentar' }}</p>
    <p class="internal-code">{{ code ? 'Código interno: ' + code : null }}</p>
  </div>
</div>
